export class CustomerDetail {
    constructor({
                    customerNumber = null,
                    contactEmail = null,
                    contactNo = null,
                } = {}) {
        this.customerNumber = customerNumber;
        this.contactEmail = contactEmail;
        this.contactNo = contactNo;
    }
}
export function createCustomerDetail(data) {
    return Object.freeze(new CustomerDetail(data));
}
